import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    emptyRatings: {
      textAlign: 'center',
    },
  }),
);

export default useStyles;
